import { sendEvent } from '../events'

export const UPDATE_FILTER = 'positions/UPDATE_FILTER'
export const FETCH_POSITIONS = 'positions/FETCH_POSITIONS'
export const UPDATE_POSITIONS = 'positions/UPDATE_POSITIONS'
export const LINKEDIN_LOGIN_START = 'positions/LINKEDIN_LOGIN_START'
export const LINKEDIN_LOGIN_END = 'positions/LINKEDIN_LOGIN_START'
export const LINKEDIN_LOGIN = 'positions/LINKEDIN_LOGIN'
export const TOGGLE_OPT_IN = 'positions/TOGGLE_OPT_IN'


const initialState = {
  isUpdating: false,
  positions: [],

  companies: [],
  locations: [],
  skills: [],
  roles: [],

  filtering: false,
  filter: {
    skill: [],
    company: [],
    location: [],
    role: []
  },

  user: null,
  showLogin: true,
  showWelcomeBackOnReturn: false,
  optIn: false,
  linkedinLoading: false,
}

export default (state = initialState, {type, positions, companies, skills, locations, roles, filter, user}) => {
  switch (type) {
    case LINKEDIN_LOGIN_START:
      return {
        ...state,
        linkedinLoading: true,
      }
    case LINKEDIN_LOGIN_END:
      return {
        ...state,
        linkedinLoading: false,
      }
    case TOGGLE_OPT_IN:
      return {
        ...state,
        optIn: !state.optIn
      }
    case LINKEDIN_LOGIN:
      return {
        ...state,
        user,
        showWelcomeBackOnReturn: true,
        linkedinLoading: false,
      }
    case UPDATE_FILTER:
      const { skill, company, location, role } = filter

      return {
        ...state,
        filtering: [skill, company, location, role].some((filter = []) => filter.length),
        filter: {
          ...state.filter,
          ...(skill && {skill}),
          ...(company && {company}),
          ...(location && {location}),
          ...(role && {role})
        }
      }
    case FETCH_POSITIONS:
      return {
        ...state,
        isUpdating: true
      }

    case UPDATE_POSITIONS:
      return {
        ...state,
        isUpdating: false,
        positions,
        companies,
        locations,
        skills,
        roles
      }
    default:
      return state
  }
}
const formatValues = (values) => values.map((value) => ({label: value, value: value.toLowerCase()}))
const getCountry = (location) => location.split(',').pop().trim()
export const fetchPositions = () => {
  return dispatch => {
    dispatch({
      type: FETCH_POSITIONS
    })
    return fetch(process.env.NODE_ENV === 'development' ? `${process.env.PUBLIC_URL}/jobs.json`:`https://s3.amazonaws.com/jobs.aleph.vc/jobs.json`)
      .then(r => r.json())
      .then(positions => {
        const locations = []
        const skills = [
          'Engineering',
          'Product',
          'Design',
          'Bizdev and Sales',
          'Marketing and Growth',
          'Operations and Finance' ,
          'Other'
        ]

        const companies = Array.from(new Set(positions.map(({company}) => company)))
        const roles = []

        positions.forEach(({location, role = ''}) => {
          if(null === role) {
            role = ''
          }

          if(null === location) {
            location = ''
          }

          !~locations.indexOf(location) && location.trim() !== '' && locations.push(location)
          !~roles.indexOf(role) && role.trim() !== '' && roles.push(role)
        })


        dispatch({
          type: UPDATE_POSITIONS,
          positions,
          companies: formatValues(companies.sort()),
          skills: formatValues(skills),
          locations: formatValues(
            locations.sort((a, b) =>
              getCountry(a).localeCompare(getCountry(b))
            )
          ),
          roles: [{label: 'Any', value: ''}, ...formatValues(roles.sort())]
        })
      })
  }
}

export const updateFilter = (type, value) => {
  return dispatch => {
    dispatch({
      type: UPDATE_FILTER,
      filter: {[type]: value}
    })
  }
}

export const linkedinLogin = (user) => {
  return dispatch => {
    sendEvent('Login', user)
    dispatch({
      type: LINKEDIN_LOGIN,
      user
    })
  }
}


export const handleLinkedinRedirect = (store) => {
  const state = store.getState()
  const removeParam = (path, param) => '?' + path.slice(1).split('&').filter(p => p.split('=')[0] !== param).join('&')
  const linkedinCode = (new URL(window.location.href)).searchParams.get('code')
  if (linkedinCode !== null) {
    console.log('linkedinCode:', linkedinCode)
    const newPath = "/" + ['code', 'error', 'state'].reduce(removeParam, window.location.search)
    window.history.pushState({}, document.title, newPath === '/?' ? '/' : newPath)
    store.dispatch({
      type: LINKEDIN_LOGIN_START,
    })
    fetch(`https://8pum13h8t5.execute-api.us-east-1.amazonaws.com/default/linkedin-get-token?code=${linkedinCode}&redirect_uri=${window.location.href}&opt_in=${state.positions.optIn}`, {mode: 'cors'}).then(res => {
      return res.json()
    })
    .then(profile => {
      const user = {
        _profile: {
          name: profile.firstName + " " + profile.lastName,
          email: profile.emailAddress,
          publicProfileURL: profile.publicProfileUrl,
        }
      }
      store.dispatch(linkedinLogin(user))
      if (state.positions.optIn) {
        sendEvent('Opt-in', user)
      }
    })
    .catch(() => {
      store.dispatch({
        type: LINKEDIN_LOGIN_END,
      })
    })
  }
}

export const belatedOptin = (store) => {
  const user = store.getState().positions.user
  const profile = user._profile
  const publicProfileURL = profile.publicProfileURL
  fetch(`https://8pum13h8t5.execute-api.us-east-1.amazonaws.com/default/linkedin-get-token?action=belated_optin&publicProfileUrl=${publicProfileURL}`, {mode: 'cors'})
  .then(() => {
    store.dispatch({ type: TOGGLE_OPT_IN })
    sendEvent('Opt-in', user)
  })
}


// WEBPACK FOOTER //
// ./src/modules/positions.js